import url from '@/creditflowresearch/infrastructure/url';
import { IArticleWithMappedData, ITheme } from '@/creditflowresearch/domain/vo/ArticlesAndStats/Article';

const getArticleMetaSchema = (pathname: string, article: IArticleWithMappedData) => {
  const {
    headline,
    description,
    author,
    publishedAt: date,
    themes,
    sectorOrIndustry,
  } = article;

  return {
    '@context': 'https://schema.org',
    '@type': 'Article',
    url: url.getUrl(pathname),
    headline,
    description,
    keywords: [
      sectorOrIndustry,
      ...themes.map((theme: ITheme) => theme.displayName),
      'credit flow',
      'fixed income',
    ],
    author: {
      '@type': 'Organization',
      name: author.name,
    },
    datePublished: date,
    isAccessibleForFree: false,
    hasPart: {
      '@type': 'WebPageElement',
      isAccessibleForFree: false,
      cssSelector: '[data-test="articleSections"]',
    },
  };
};

export default getArticleMetaSchema;
